export default __webpack_public_path__ + "static/media/undraw_my_answer_re_k4dv.edbd7ba2.svg";